import { useSelector } from "react-redux";
import "../css/Banner.css";
import { useAppRedirects } from "../hooks";
import { getAccountState } from "../redux/slices/accountSlice";
import { formatPhoneNumber } from "../utils/FormatPhoneNumber";
import {
  isProductSpecificType,
  MARKIT_FREE_CREATOR_NUMBER,
} from "@markit/common.utils";
import React, { useMemo, useState } from "react";
import { useTheme } from "../hooks/useTheme";
import RectangleButton from "./Buttons/RectangleButton";
import AlertButtonWrapper from "./Containers/AlertButtonWrapper";
import { EventType } from "@markit/common.types";

export enum BannerType {
  TEXTHOST,
  TEXTHOST_FREE,
}

type BannerProps = {
  type?: BannerType;
  hostPhone?: string;
  bannerStyles?: React.CSSProperties;
  eventType?: EventType;
};

const Banner = (props: BannerProps) => {
  const { type, hostPhone, bannerStyles, eventType } = props;
  const { account } = useSelector(getAccountState);
  const { isRCA } = account;
  const { redirectToAppStore: onAppStoreClick } = useAppRedirects();

  const { theme } = useTheme();

  const [alertText, setAlertText] = useState("");

  const styles = {
    bannerContainer: {
      marginTop: bannerStyles?.marginTop || "0.7em",
      marginBottom: bannerStyles?.marginBottom || 0,
      border: `0.5px solid ${theme.EditableTextFieldBorder.borderColor}`,
    },
  };

  const hostNumber = useMemo(
    () => hostPhone ?? MARKIT_FREE_CREATOR_NUMBER,
    [hostPhone]
  );

  switch (type) {
    case BannerType.TEXTHOST:
      return (
        <RectangleButton
          buttonLabel={
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "14px",
                cursor: "pointer",
              }}
            >
              <span
                className="bodyBold"
                style={{ ...theme.PrimaryText, cursor: "pointer" }}
              >
                Contact
              </span>
              <span className="bodySubtext" style={{ textDecoration: "none" }}>
                {formatPhoneNumber(hostNumber)}
              </span>
            </div>
          }
          onPress={() => (window.location.href = "sms:" + hostNumber)}
          altColor={theme.NewPrimaryBG.backgroundColor}
          altPaddingVert={bannerStyles?.paddingBlock || 14}
          altPaddingHorz={bannerStyles?.paddingInline || 10}
          altBorderRadius={bannerStyles?.borderRadius || 14}
          containerStyles={styles.bannerContainer}
        />
      );

    /* TODO: IF HOST HAS NO NUMBER */
    case BannerType.TEXTHOST_FREE:
      return (
        <AlertButtonWrapper
          buttonComp={
            <RectangleButton
              buttonLabel={
                eventType && isProductSpecificType(eventType)
                  ? "Contact"
                  : "Contact Host"
              }
              onPress={() =>
                setAlertText(
                  "Please contact this person via one of their socials."
                )
              }
              altColor={theme.NewPrimaryBG.backgroundColor}
              altTextColor={theme.PrimaryText.color}
              altPaddingVert={bannerStyles?.paddingBlock || 14}
              altPaddingHorz={bannerStyles?.paddingInline || 10}
              altBorderRadius={bannerStyles?.borderRadius || 14}
              containerStyles={styles.bannerContainer}
            />
          }
          alertTextHeader={alertText}
          clearAlert={() => setAlertText("")}
        />
      );

    default:
      return (
        <div
          className="Banner"
          style={{
            ...bannerStyles,
            backgroundColor: "#f4f5f6",
          }}
        >
          <div
            className="LeftContainer"
            style={{ paddingLeft: 10, width: "55%" }}
          >
            <div className="BannerFullName" style={{ color: "#000" }}>
              <p style={{ padding: 0, margin: 0 }}>Non-US Number?</p>
            </div>
            <div className="Username" style={{ color: "#929292" }}>
              Get the app to get a ticket
            </div>
          </div>
          <div
            className="OpenButton"
            style={{
              marginRight: 7,
              backgroundColor: isRCA ? "#FE296C" : "#11b8ff",
            }}
            onClick={() => onAppStoreClick()}
          >
            <p className="OpenButtonText">Get the app</p>
          </div>
        </div>
      );
  }
};

export default Banner;
